import React, { useEffect, useState } from 'react';
import {
  SecurityContext,
  SecurityContextType,
} from '../hooks/useSecurityContext';
interface SecurityProviderProps {
  children: React.ReactNode;
}

export const SecurityProvider: React.FC<SecurityProviderProps> = ({ children }) => {
  const [securityState, setSecurityState] = useState<SecurityContextType>({
    isSecureConnection: false,
    browserSupported: true,
    securityWarnings: []
  });

  useEffect(() => {
    const checkSecurity = () => {
      const warnings: string[] = [];
      
      // Check HTTPS
      const isSecure = window.location.protocol === 'https:' || 
                      window.location.hostname === 'localhost' ||
                      window.location.hostname === '127.0.0.1';
      
      if (!isSecure) {
        warnings.push('Unsichere Verbindung erkannt. Bitte verwenden Sie HTTPS.');
      }

      // Check browser support
      const browserSupported = !!(
        window.crypto &&
        window.crypto.subtle &&
        window.localStorage &&
        window.sessionStorage
      );

      if (!browserSupported) {
        warnings.push('Ihr Browser unterstützt nicht alle erforderlichen Sicherheitsfeatures.');
      }

      // Check for development mode
      // Development mode warning removed for cleaner UI

      // Check for mixed content
      if (window.location.protocol === 'https:' && document.querySelector('script[src^="http:"]')) {
        warnings.push('Gemischte Inhalte erkannt - dies kann die Sicherheit beeinträchtigen.');
      }

      setSecurityState({
        isSecureConnection: isSecure,
        browserSupported,
        securityWarnings: warnings
      });
    };

    checkSecurity();

    // NOTE: The Content-Security-Policy is now delivered as a proper HTTP
    // header via netlify.toml / vercel.json — the runtime <meta> injection
    // used to sit here has been removed because it took effect too late
    // (after render) and forced us to relax script-src with 'unsafe-inline'.
    // If you're developing locally, add the CSP to your dev-server config.
  }, []);

  return (
    <SecurityContext.Provider value={securityState}>
      {children}
    </SecurityContext.Provider>
  );
};